import * as tslib_1 from "tslib";
import { EventBase } from "@awayjs/core";
var RendererEvent = (function (_super) {
    tslib_1.__extends(RendererEvent, _super);
    function RendererEvent(type) {
        return _super.call(this, type) || this;
    }
    return RendererEvent;
}(EventBase));
export { RendererEvent };
RendererEvent.VIEWPORT_UPDATED = "viewportUpdated";
RendererEvent.SCISSOR_UPDATED = "scissorUpdated";



// WEBPACK FOOTER //
// ../dist/lib/events/RendererEvent.js